import React from 'react'
import "./SubStyle.css"

const Soft_Allowances = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Capital allowances</h1>
      <p className="SubServices-pera">Capital allowances are a form of tax relief that allows a business to deduct the cost of certain capital assets from its taxable profits over time. These assets may include machinery, equipment, vehicles, computers, and some building-related expenditures.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Allowances
